// IE 2026 09 24 / ODOO-… (заказ Игоря: «в текущем режиме выгрузки в Excel и PDF не выгружать скрытые строки и колонки — скорость будет выше там,
// где скрытых строк много, и объём данных поменьше; дополнительно добавить команду выгрузки в Excel с учётом скрытых строк и колонок»).
//
// ВЫГРУЗКА XLSX ТОЛЬКО ВИДИМЫХ СТРОК. Факт (вырезка wijmo 5.20261.52, @mescius/wijmo.grid.xlsx): цикл FlexGridXlsxConverter._saveContentToWorksheet
// проходит ВСЕ строки всех панелей грида; для панели ячеек скрытые строки (row.isVisible = false: чипс поиска / фильтра, свёрнутые группы) не
// пропускаются — каждая стоит полного прохода по ячейкам (объединения через наш CustomMergeManager, стили через updateCell + getComputedStyle,
// formatItem) и попадает в книгу как строка hidden. Скрытые колонки — то же (hidden), но у них есть штатная опция includeColumns (её ставит
// mainStore.exportGrid). Рекурсия цикла по порциям идёт через СТАТИЧЕСКОЕ свойство FlexGridXlsxConverter._saveContentToWorksheet — подмена
// статика подхватывается конвертером как есть.
//
// Что делает модуль: один раз (install) подменяет статик _saveContentToWorksheet СВОЕЙ копией того же цикла (та же сигнатура из 19 аргументов,
// те же порции / setTimeout / cancel / progress / done). Отличие одно: пока идёт выгрузка в режиме «только видимые» (begin(flex) … end()), строка
// панели ячеек с !row.isVisible пропускается БЕЗ инкремента globRowIdx (в книге нет дыр в нумерации строк); у выгружаемых group-строк снимается
// collapsed (их скрытые дети не выгружены — Excel не должен показывать «+» на пустом); у ячеек с rowSpan > 1 (вертикальное объединение) rowSpan
// заменяется числом ВИДИМЫХ строк диапазона (страховка: замер 24.09 — на реальных гридах dev / dev02 в панели ячеек вертикальных объединений нет,
// они возможны только у колонок с mergeRows и у печатных форм). ОГРАНИЧЕНИЕ: если якорная (верхняя) строка вертикального объединения скрыта, её
// значение в файл не попадает (как и сейчас оно попадало бы в скрытую строку); у mergeRows-колонок якорь по построению — первая видимая строка.
// Скрытые строки среди закреплённых (frozen) учитываются: frozenPane.rows уменьшается на их число.
// Попутная особенность штатной опции includeColumns (замер 24.09 на «Purchase Balance»): флаг E «якорь объединения исключён» в
// _parseFlexGridRowToSheetRow не сбрасывается на якорях СЛЕДУЮЩИХ диапазонов — после скрытой одиночной колонки шапки (Alert) первая видимая
// колонка ВНУТРИ следующей группы (Feb под «2026») получала значение группы и colSpan поверх уже выгруженного якоря (второе «2026» под
// объединением). В режиме «только видимые» ячейки, накрытые colSpan соседа слева в той же строке, очищаются (clearCoveredCells).
//
// Защита версии: подмена только если статик — функция из 19 аргументов и её текст несёт маркеры (_NewRowTemplate, _parseFlexGridRowToSheetRow,
// _addWorkbookRow, globRowIdx); иначе — один console.warn, выгрузка идёт штатно (как раньше), supported() = false.
//
// Внешние ссылки копии (все экспортированы из модулей @mescius/wijmo*): wjcXlsx.WorkbookRow, wjcGrid.CellType, wjcGrid._NewRowTemplate,
// wjcGrid.GroupRow, wjcCore.isFunction; FlexGridXlsxConverter._parseFlexGridRowToSheetRow — статик того же конвертера.
//
// Юнит: handoff-files/xlsx-visible-only-2026-09-24/xlsxVisibleOnly.test.mjs (фейковые панели / строки). Проба: tools/probes/xlsxexport_check.mjs.

const MARKERS = ['_NewRowTemplate', '_parseFlexGridRowToSheetRow', '_addWorkbookRow', 'globRowIdx']
const ORIG_ARITY = 19

let _installed = false
let _supported = false
let _warned = false
let _mode = null    // { flex, stats } — пока идёт выгрузка «только видимые»

function _warn(msg) {
    if (_warned) return
    _warned = true
    try { console.warn('[xlsxVisibleOnly] ' + msg + ' — XLSX export runs the stock wijmo loop (hidden rows are exported as hidden)') } catch (e) { /* no console */ }
}

/** Пригодна ли эта сборка wijmo для подмены (без побочных действий). */
export function xlsxVisibleOnly_check(wjcGridXlsx, wjcGrid, wjcXlsx) {
    const Conv = wjcGridXlsx && wjcGridXlsx.FlexGridXlsxConverter
    const orig = Conv && Conv._saveContentToWorksheet
    if (typeof orig !== 'function') return { ok: false, reason: 'no _saveContentToWorksheet' }
    if (orig.length !== ORIG_ARITY) return { ok: false, reason: `arity ${orig.length} != ${ORIG_ARITY}` }
    let src = ''
    try { src = Function.prototype.toString.call(orig) } catch (e) { src = '' }
    const missing = MARKERS.filter(m => !src.includes(m))
    if (missing.length) return { ok: false, reason: 'markers missing: ' + missing.join(', ') }
    if (typeof Conv._parseFlexGridRowToSheetRow !== 'function') return { ok: false, reason: 'no _parseFlexGridRowToSheetRow' }
    if (!wjcXlsx || typeof wjcXlsx.WorkbookRow !== 'function') return { ok: false, reason: 'no WorkbookRow' }
    if (!wjcGrid || !wjcGrid.CellType || typeof wjcGrid._NewRowTemplate !== 'function' || typeof wjcGrid.GroupRow !== 'function') return { ok: false, reason: 'grid exports missing' }
    return { ok: true, reason: '' }
}

/**
 * Подменить статик FlexGridXlsxConverter._saveContentToWorksheet копией с пропуском скрытых строк (один раз на приложение).
 * Возвращает true, если подмена состоялась (или уже была).
 */
export function xlsxVisibleOnly_install(wjcGridXlsx, wjcGrid, wjcXlsx, wjcCore) {
    if (_installed) return _supported
    _installed = true
    const chk = xlsxVisibleOnly_check(wjcGridXlsx, wjcGrid, wjcXlsx)
    if (!chk.ok) { _supported = false; _warn('unsupported wijmo build: ' + chk.reason); return false }
    const Conv = wjcGridXlsx.FlexGridXlsxConverter
    if (!Conv._saveContentToWorksheet_orig) Conv._saveContentToWorksheet_orig = Conv._saveContentToWorksheet
    Conv._saveContentToWorksheet = makeSaveContentToWorksheet(Conv, wjcGrid, wjcXlsx, wjcCore)
    _supported = true
    return true
}

export function xlsxVisibleOnly_supported() { return _installed && _supported }

/** Включить режим «только видимые» для ближайшей выгрузки этого грида; возвращает объект статистики (заполняется по ходу). */
export function xlsxVisibleOnly_begin(flex) {
    _mode = { flex, stats: newStats() }
    return _mode.stats
}

/** Выключить режим; возвращает статистику выгрузки (null, если режим не включался). */
export function xlsxVisibleOnly_end() {
    const s = _mode ? _mode.stats : null
    _mode = null
    return s
}

export function xlsxVisibleOnly_active(flex) { return !!_mode && (!flex || _mode.flex === flex) }

/** Скрытые строки / колонки грида — для листа INFO и уведомления (O(rows + cols), без обращения к ячейкам). */
export function xlsxVisibleOnly_hiddenCounts(flex) {
    let rows = 0, cols = 0
    try {
        for (const r of flex.rows) if (!r.isVisible) rows++
        for (const c of flex.columns) if (!(c.isVisible && c.renderWidth > 0)) cols++
    } catch (e) { /* грид без коллекций — нули */ }
    return { rows, cols }
}

/** Фильтр колонок для saveAsync ({includeColumns}): данные — только видимые; колонки заголовков строк — всегда (у них свои workbook-колонки). */
export function xlsxVisibleOnly_includeColumns(flex) {
    const headerCols = new Set()
    try { for (const c of flex.rowHeaders.columns) headerCols.add(c) } catch (e) { /* нет панели */ }
    try { for (const c of flex.topLeftCells.columns) headerCols.add(c) } catch (e) { /* нет панели */ }
    return (col) => headerCols.has(col) || !!(col && col.isVisible && col.renderWidth > 0)
}

function newStats() {
    return { skippedRows: 0, exportedRows: 0, skippedFrozen: 0, groupRowsUncollapsed: 0, rowSpanFixed: 0, coveredCleared: 0 }
}

/** Число видимых строк панели в диапазоне [r1, r2] (r2 обрезается по длине коллекции). */
export function visibleRowsBetween(rows, r1, r2) {
    let n = 0
    const last = Math.min(r2, rows.length - 1)
    for (let i = r1; i <= last; i++) if (rows[i] && rows[i].isVisible) n++
    return n
}

/**
 * Ячейки строки книги, накрытые colSpan ячейки левее в той же строке, — пустые (значение / формула / спаны сняты): wijmo с фильтром
 * includeColumns может дать такой ячейке значение и colSpan повторно (см. шапку модуля); Excel показывает только якорь объединения.
 */
export function clearCoveredCells(G, stats) {
    const cells = G.cells || []
    let cover = 0
    for (let i = 0; i < cells.length; i++) {
        const cell = cells[i]
        if (cover > 0) {
            cover--
            if (cell && ((cell.value !== null && cell.value !== undefined && cell.value !== '') || cell.colSpan > 1 || cell.rowSpan > 1 || cell.formula)) {
                cell.value = null; cell.formula = null; cell.textRuns = null; cell.colSpan = 1; cell.rowSpan = 1
                if (stats) stats.coveredCleared++
            }
            continue
        }
        if (cell && cell.colSpan > 1) cover = cell.colSpan - 1
    }
    return G
}

/**
 * Правка строки книги в режиме «только видимые» (панель ячеек): collapsed снимается, rowSpan ячеек — по видимым строкам диапазона.
 * G — объект строки до _deserialize ({cells, visible, height, groupLevel, collapsed}); rows — panel.rows; r — индекс строки в панели.
 */
export function fixVisibleOnlyRow(G, rows, r, stats) {
    if (G.collapsed) { G.collapsed = false; if (stats) stats.groupRowsUncollapsed++ }
    const cells = G.cells || []
    for (let i = 0; i < cells.length; i++) {
        const cell = cells[i]
        if (!cell || !(cell.rowSpan > 1)) continue
        const span = visibleRowsBetween(rows, r, r + cell.rowSpan - 1)
        if (span !== cell.rowSpan) { cell.rowSpan = Math.max(1, span); if (stats) stats.rowSpanFixed++ }
    }
    return G
}

/**
 * Копия FlexGridXlsxConverter._saveContentToWorksheet (wijmo 5.20261.52) читаемым кодом. Аргументы — как у оригинала:
 *   cancel        — _SyncPromise отмены (cancel.cancelled)                 sheet             — WorkSheet, куда кладутся строки
 *   isAsync       — порции через setTimeout                                includeRowHeaders — панель заголовков строк тоже выгружается
 *   startTime     — Date.now() начала порции                               colsSettingsOf    — (cellType) => настройки колонок листа
 *   startIdx      — глобальный индекс строки, с которого продолжать        cellStyles        — режим стилей (0 None / 1 Regular / 2 Cache)
 *   ctx           — {panels, panelIdx, globRowIdx, rowsOffset, totalRows, mergedCellsCache}
 *   flex          — грид                                                   measureDiv, styleCells, styleCache, includeColumns, htmlEntities, formatItem
 *   onProgress    — (глобальный индекс) на границе порции                  onDone — по завершении всех строк; batchRows — строк на порцию
 */
export function makeSaveContentToWorksheet(Conv, wjcGrid, wjcXlsx, wjcCore) {
    const CellType = wjcGrid.CellType
    const GroupRow = wjcGrid.GroupRow
    const NewRowTemplate = wjcGrid._NewRowTemplate
    const WorkbookRow = wjcXlsx.WorkbookRow
    const isFunction = (wjcCore && typeof wjcCore.isFunction === 'function') ? wjcCore.isFunction : (f) => typeof f === 'function'

    return function _saveContentToWorksheet(cancel, isAsync, startTime, startIdx, ctx, flex, sheet, includeRowHeaders, colsSettingsOf,
                                            cellStyles, measureDiv, styleCells, styleCache, includeColumns, htmlEntities, formatItem,
                                            onProgress, onDone, batchRows) {
        const batch = batchRows || (cellStyles ? 20 : 200)
        const mode = (_mode && _mode.flex === flex) ? _mode : null
        const stats = mode ? mode.stats : null
        for (let idx = startIdx; idx < ctx.totalRows; idx++) {
            if (cancel && cancel.cancelled) return
            if (isAsync && idx - startIdx > batch && Date.now() - startTime > 100) {
                setTimeout(() => {
                    if (cancel && cancel.cancelled) return
                    onProgress(idx)
                    Conv._saveContentToWorksheet(cancel, isAsync, Date.now(), idx, ctx, flex, sheet, includeRowHeaders, colsSettingsOf,
                                                 cellStyles, measureDiv, styleCells, styleCache, includeColumns, htmlEntities, formatItem,
                                                 onProgress, onDone, batchRows)
                }, 0)
                return
            }
            while (idx - ctx.rowsOffset >= ctx.panels[ctx.panelIdx][1].rows.length) {
                ctx.rowsOffset += ctx.panels[ctx.panelIdx][1].rows.length
                ctx.panelIdx++
            }
            const pair = ctx.panels[ctx.panelIdx]
            const headerPanel = pair[0]
            const panel = pair[1]
            const r = idx - ctx.rowsOffset
            const row = panel.rows[r]
            const isCells = panel.cellType === CellType.Cell
            if ((!isCells && row.renderSize <= 0) || row instanceof NewRowTemplate) continue
            if (mode && isCells && !row.isVisible) {
                // IE 2026 09 24: скрытая строка данных — не выгружается и не занимает номер строки в книге
                stats.skippedRows++
                if (r < (flex.frozenRows || 0)) stats.skippedFrozen++
                continue
            }
            const G = {}
            const wbRow = new WorkbookRow()
            const isGroup = row instanceof GroupRow
            let level = 0
            if (isCells) {
                if (isGroup) level = row.level
                else if (flex.rows.maxGroupLevel > -1) level = flex.rows.maxGroupLevel + 1
            }
            const colSettings = colsSettingsOf(panel.cellType)
            let offset = 0
            if (includeRowHeaders) {
                offset = Conv._parseFlexGridRowToSheetRow(sheet, headerPanel, G, r, 0, colSettings, cellStyles, measureDiv, styleCells, styleCache,
                                                          isGroup, level, includeColumns, htmlEntities, ctx.mergedCellsCache, formatItem)
            }
            Conv._parseFlexGridRowToSheetRow(sheet, panel, G, r, offset, colSettings, cellStyles, measureDiv, styleCells, styleCache,
                                             isGroup, level, includeColumns, htmlEntities, ctx.mergedCellsCache, formatItem)
            if (mode) {
                clearCoveredCells(G, stats)
                if (isCells) { fixVisibleOnlyRow(G, panel.rows, r, stats); stats.exportedRows++ }
            }
            if (G.cells.length > 0) {
                wbRow._deserialize(G)
                sheet._addWorkbookRow(wbRow, ctx.globRowIdx)
            }
            ctx.globRowIdx++
        }
        if (isFunction(onDone)) {
            onDone()
            // закреплённая область считается вызывающим по flex.rows.frozen (все строки): скрытые среди закреплённых в книге нет
            if (stats && stats.skippedFrozen && sheet && sheet.frozenPane && sheet.frozenPane.rows > 0) {
                sheet.frozenPane.rows = Math.max(0, sheet.frozenPane.rows - stats.skippedFrozen)
            }
        }
    }
}

export default {
    install: xlsxVisibleOnly_install, check: xlsxVisibleOnly_check, supported: xlsxVisibleOnly_supported,
    begin: xlsxVisibleOnly_begin, end: xlsxVisibleOnly_end, active: xlsxVisibleOnly_active,
    hiddenCounts: xlsxVisibleOnly_hiddenCounts, includeColumns: xlsxVisibleOnly_includeColumns,
}
